import { postAction } from '@/api/manage';
export default {
  name: "Step2",
  props: ['userList'],
  data: function data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      // accountName: this.userList.username,
      dropList: "0",
      captcha: "",
      show: true,
      state: {
        time: 60,
        smsSendBtn: false
      },
      formLogin: {
        captcha: "",
        mobile: ""
      },
      validatorRules: {
        captcha: {
          rule: [{
            required: true,
            message: '请输入验证码!'
          }, {
            validator: this.validateCaptcha
          }]
        },
        phone: {
          rule: [{
            required: true,
            message: '请输入手机号或邮箱!'
          }, {
            validator: this.validatePhoneOrEamil
          }]
        }
      }
    };
  },
  computed: {},
  methods: {
    nextStep: function nextStep() {
      var _this = this;
      var that = this;
      that.loading = true;
      this.form.validateFields(function (err, values) {
        console.log(values);
        if (!err) {
          if (that.dropList == "0") {
            if (values.captcha == undefined) {
              _this.cmsFailed("请输入验证码!");
            } else {
              var params = {};
              params.phone = values.phone;
              params.smscode = values.captcha;
              postAction("/sys/user/phoneVerification", params).then(function (res) {
                if (res.success) {
                  console.log(res);
                  var userList = {
                    username: res.result.username,
                    phone: values.phone,
                    smscode: res.result.smscode
                  };
                  setTimeout(function () {
                    that.$emit('nextStep', userList);
                  }, 0);
                } else {
                  _this.cmsFailed(res.message);
                }
              });
            }
          }
        }
      });
    },
    getCaptcha: function getCaptcha(e) {
      var _this2 = this;
      e.preventDefault();
      var that = this;
      var phone = that.form.getFieldValue("phone");
      if (!phone) {
        this.cmsFailed("手机号不能为空!");
        return;
      }
      this.state.smsSendBtn = true;
      var interval = window.setInterval(function () {
        if (that.state.time-- <= 0) {
          that.state.time = 60;
          that.state.smsSendBtn = false;
          window.clearInterval(interval);
        }
      }, 1000);
      var hide = this.$message.loading('验证码发送中..', 0);
      var smsParams = {
        mobile: phone,
        smsmode: "2"
      };
      postAction("/sys/sms", smsParams).then(function (res) {
        if (!res.success) {
          setTimeout(hide, 1);
          _this2.cmsFailed(res.message);
        }
        setTimeout(hide, 500);
      });
    },
    cmsFailed: function cmsFailed(err) {
      this.$notification['error']({
        message: "验证错误",
        description: err,
        duration: 4
      });
    },
    handleChangeSelect: function handleChangeSelect(value) {
      var that = this;
      console.log(value);
      if (value == 0) {
        that.dropList = "0";
        that.show = true;
      } else {
        that.dropList = "1";
        that.show = false;
      }
    },
    validatePhoneOrEamil: function validatePhoneOrEamil(rule, value, callback) {
      if (value) {
        var phonereg = /^1[3456789]\d{9}$/;
        var emailreg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/;
        if (!phonereg.test(value) && !emailreg.test(value)) {
          callback("请输入正确的手机号或邮箱");
        } else {
          callback();
        }
      } else {
        callback();
      }
    }
  }
};